/*
 * Добавляет фильтры для атрибутов, чтобы можно было
 * использовать attrs и listeners отдельно
 */
import { defineNuxtPlugin } from 'nuxt/app'

import {
  getAttrs,
  getAttrsAll,
  getClassAndStyle,
  getListeners,
} from '@ga/utils'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      getAttrs, // аналог vue2 $attrs - атрибуты без class и style
      getAttrsAll, // все атрибуты - за исключением $listeners
      getListeners, // только слушатели, аналог vue2 $listeners
      getClassAndStyle, // class и style, который ранее привязывались всегда
    },
  }
})
